var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExamen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 80,
    viewBox: "0 0 120 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1026_1398)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M41.5443 62.0398C52.8215 62.5725 56.3337 54.6558 74.0848 57.8017C88.2611 60.3557 94.258 50.5426 96.0417 44.4321C96.8969 41.5134 97.0199 30.1264 89.2675 30.0989C62.8953 29.6209 41.5178 0.394026 29.043 26.187C16.5682 51.98 16.0247 60.8386 41.5443 62.0398Z",
    fill: "#B198F8"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1026_1398)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 9.21436,
    width: 48,
    height: 60.5714,
    rx: 6,
    fill: "white"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 41.7142,
    y: 42.3572,
    width: 8,
    height: 8,
    rx: 2,
    fill: "#F9F6FE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.7142,
    y: 54.9287,
    width: 8,
    height: 8,
    rx: 2,
    fill: "#F9F6FE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.7142,
    y: 30.9287,
    width: 8,
    height: 8,
    rx: 2,
    fill: "#F9F6FE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.7142,
    y: 18.3572,
    width: 8,
    height: 8,
    rx: 2,
    fill: "#F9F6FE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.1428,
    y: 19.5,
    width: 27.4286,
    height: 2.28571,
    rx: 1.14286,
    fill: "#F9F6FE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.1428,
    y: 32.0715,
    width: 27.4286,
    height: 2.28571,
    rx: 1.14286,
    fill: "#F9F6FE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.1428,
    y: 43.5,
    width: 27.4286,
    height: 2.28571,
    rx: 1.14286,
    fill: "#F9F6FE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.1428,
    y: 56.0715,
    width: 27.4286,
    height: 2.28571,
    rx: 1.14286,
    fill: "#F9F6FE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.1428,
    y: 22.9287,
    width: 13.7143,
    height: 2.28571,
    rx: 1.14286,
    fill: "#F9F6FE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.1428,
    y: 35.5,
    width: 13.7143,
    height: 2.28571,
    rx: 1.14286,
    fill: "#F9F6FE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.1428,
    y: 46.9287,
    width: 13.7143,
    height: 2.28571,
    rx: 1.14286,
    fill: "#F9F6FE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.1428,
    y: 59.5,
    width: 13.7143,
    height: 2.28571,
    rx: 1.14286,
    fill: "#F9F6FE"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1026_1398)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 84,
    cy: 32,
    r: 17,
    fill: "white"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 84,
    cy: 32,
    r: 14,
    fill: "url(#paint0_linear_1026_1398)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.0223 35.4187C75.7591 35.4187 75.4894 35.3866 75.2134 35.3224C74.9437 35.2582 74.6902 35.1619 74.4526 35.0335C74.2985 34.9564 74.1894 34.8537 74.1252 34.7253C74.0674 34.5905 74.0481 34.4524 74.0674 34.3112C74.0867 34.1635 74.138 34.0319 74.2215 33.9164C74.305 33.8008 74.4141 33.7238 74.5489 33.6853C74.6837 33.6403 74.841 33.6564 75.0208 33.7334C75.2134 33.8233 75.3931 33.8843 75.5601 33.9164C75.727 33.9485 75.8875 33.9645 76.0416 33.9645C77.0046 33.9645 77.4861 33.3675 77.4861 32.1733V32.1059C77.3512 32.382 77.149 32.5971 76.8794 32.7511C76.6162 32.9052 76.3144 32.9823 75.9742 32.9823C75.6018 32.9823 75.2647 32.8892 74.963 32.703C74.6677 32.5104 74.4334 32.2472 74.26 31.9133C74.0867 31.5795 74 31.2007 74 30.777C74 30.3147 74.0995 29.9071 74.2985 29.554C74.4975 29.2009 74.7736 28.9248 75.1267 28.7258C75.4798 28.5204 75.8875 28.4176 76.3497 28.4176C77.2421 28.4176 77.929 28.7162 78.4105 29.3132C78.8985 29.9103 79.1424 30.7577 79.1424 31.8555C79.1424 32.6003 79.0172 33.2391 78.7669 33.7719C78.5229 34.3048 78.1666 34.7125 77.6979 34.9949C77.2293 35.2774 76.6707 35.4187 76.0223 35.4187ZM76.446 31.6341C76.6964 31.6341 76.8954 31.5506 77.0431 31.3837C77.1972 31.2103 77.2742 30.9824 77.2742 30.6999C77.2742 30.4175 77.1972 30.1928 77.0431 30.0258C76.8954 29.8525 76.6964 29.7658 76.446 29.7658C76.1956 29.7658 75.9934 29.8525 75.8393 30.0258C75.6917 30.1928 75.6178 30.4175 75.6178 30.6999C75.6178 30.9824 75.6917 31.2103 75.8393 31.3837C75.9934 31.5506 76.1956 31.6341 76.446 31.6341Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7469 35.5246C80.6763 35.73 80.5607 35.8681 80.4002 35.9387C80.2461 36.0093 80.0856 36.0189 79.9187 35.9676C79.7518 35.9226 79.6202 35.8263 79.5239 35.6787C79.434 35.5374 79.4244 35.3577 79.495 35.1394L81.6328 28.4754C81.697 28.2636 81.8094 28.1255 81.9699 28.0613C82.1304 27.9907 82.2909 27.9811 82.4514 28.0324C82.6183 28.0774 82.7467 28.1737 82.8366 28.3213C82.9329 28.4626 82.9457 28.6423 82.8751 28.8606L80.7469 35.5246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.3738 35.3127C83.8859 35.3127 83.642 35.072 83.642 34.5905C83.642 34.1154 83.8859 33.8779 84.3738 33.8779H85.2405V30.4399L84.6531 30.7962C84.4862 30.899 84.3289 30.9407 84.1813 30.9214C84.0336 30.8958 83.9084 30.8316 83.8057 30.7288C83.703 30.6261 83.6355 30.5009 83.6034 30.3533C83.5713 30.2056 83.5842 30.0579 83.642 29.9103C83.6997 29.7626 83.8153 29.6374 83.9887 29.5347L85.3176 28.7065C85.6065 28.5268 85.9114 28.4369 86.2324 28.4369C86.4764 28.4369 86.6658 28.5011 86.8006 28.6295C86.9354 28.7515 87.0028 28.9312 87.0028 29.1688V33.8779H87.7732C88.2612 33.8779 88.5051 34.1154 88.5051 34.5905C88.5051 35.072 88.2612 35.3127 87.7732 35.3127H84.3738Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5252 35.4187C90.6842 35.4187 90.0422 35.1137 89.5992 34.5038C89.1562 33.8875 88.9347 33.0176 88.9347 31.8941C88.9347 30.7641 89.1562 29.9039 89.5992 29.3132C90.0422 28.7162 90.6842 28.4176 91.5252 28.4176C92.3662 28.4176 93.0082 28.7162 93.4512 29.3132C93.8942 29.9039 94.1157 30.7609 94.1157 31.8844C94.1157 33.0144 93.8942 33.8875 93.4512 34.5038C93.0082 35.1137 92.3662 35.4187 91.5252 35.4187ZM91.5252 34.0127C91.8333 34.0127 92.0613 33.8458 92.2089 33.5119C92.363 33.1717 92.44 32.6292 92.44 31.8844C92.44 31.1461 92.363 30.6197 92.2089 30.3051C92.0613 29.9841 91.8333 29.8236 91.5252 29.8236C91.217 29.8236 90.9859 29.9841 90.8318 30.3051C90.6842 30.6197 90.6103 31.1461 90.6103 31.8844C90.6103 32.6292 90.6842 33.1717 90.8318 33.5119C90.9859 33.8458 91.217 34.0127 91.5252 34.0127Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1026_1398",
    x: 30,
    y: 3.21436,
    width: 60,
    height: 72.5715,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.0313726 0 0 0 0 0.337255 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1026_1398"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1026_1398",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1026_1398",
    x: 61,
    y: 9,
    width: 46,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.0313726 0 0 0 0 0.337255 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1026_1398"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1026_1398",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1026_1398",
    x1: 84,
    y1: 18,
    x2: 84,
    y2: 46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8258F3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1026_1398"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 80,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExamen);
export default __webpack_public_path__ + "static/media/examen.79a4da173c0ef32b9986e3bfd096b64f.svg";
export { ForwardRef as ReactComponent };